module.exports = __webpack_public_path__ + "img/03.ee60a3eb.jpg";